export const appVersion = '3.3.59';

export const ogSiteName = 'پلتفرم تماشای آنلاین فیلم و سریال شیدا';

export const siteAssetsBaseUrl = 'https://static-s.sheyda.com/site-assets';

export const staticImages = {
  aboutUs: `${siteAssetsBaseUrl}/about-us.jpeg?imgProcess=pr:fjpeg:w1024`,
  logo: `${siteAssetsBaseUrl}/logo.svg`,
  authBackground: `${siteAssetsBaseUrl}/background.jpg?imgProcess=pr:fjpeg:w1440`,
  miniLogoDark: `${siteAssetsBaseUrl}/mini-logo-dark.svg`,
  miniLogoWhite: `${siteAssetsBaseUrl}/mini-logo-white.svg`,
  onlineScreenSheyda: `${siteAssetsBaseUrl}/online-screen-sheyda.svg`,
};

export enum variables {
  accessToken = 'atk',
  refreshToken = 'rtk',
  ga4UserId = 'gauid',
  tmtToken = 'tmt',
  did = 'did',
  tmpPhone = 'temp-phone',
  tmpCode = 'temp-code',
  playerMuted = 'pm',
}
